export const WHATSAPP_NUMBER = '96896052773';
export const WHATSAPP_MESSAGE = 'Hi%20Oman%20Disposables%2C%20I%20need%20wholesale%20pricing%20for%20gloves.%20Please%20send%20me%20details.';
export const WHATSAPP_URL = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${WHATSAPP_MESSAGE}`;
